/**
 * Fixed copy for the two automated lines in a founder↔investor thread.
 *
 * A leaf module with no runtime imports, so the sender, the thread renderer and
 * the tests can all share one definition instead of three string literals that
 * drift.
 *
 * THE TWO ARE NOT THE SAME KIND OF THING, deliberately:
 *
 *   REQUEST_ACCESS_MESSAGE is a REAL message row, authored by the investor
 *   (`sender_id = auth.uid()`, `sender_type = 'investor'`). It belongs in both
 *   participants' threads because it is the ask itself — the founder has to see
 *   it to answer it.
 *
 *   ACCESS_REJECTED_LINE is NOT stored. It is rendered from the request's own
 *   `status = 'rejected'`, investor-side only. Storing it would need either a
 *   `messages.kind` column or a sentinel uuid pretending to be a sender, since
 *   `sender_id`/`sender_type` are both NOT NULL and there is no system-author
 *   concept. Deriving it costs nothing, cannot duplicate if a founder toggles
 *   their answer twice, cannot be forged, and keeps text addressed TO the
 *   investor out of the founder's thread — which a stored row would force.
 */

/** Posted into the thread when an investor asks for data-room access. */
export const REQUEST_ACCESS_MESSAGE = "I've requested access to your data room.";

/** Rendered (never stored) in the investor's thread once a request is rejected. */
export const ACCESS_REJECTED_LINE =
  'Your request has been rejected. You can further ask the founder about the rejection here.';
